/**
 * @author Harshitha.k
 * @description 
 */

import './css/map.css';
import L from 'leaflet';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'leaflet/dist/leaflet.css';
import LeftSidePanel from './LeftSidePanel';
import { LeftSquareFilled } from '@ant-design/icons';
import localStorage from '../../../../../utils/localStorage';
import { MapContainer as Map, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import StyledTable from "../../../../../commons/styles/table";
import { _getMarkerList, _getTableData, getDataForPopup } from './apicalls';

const MapWithClustering = (props) => {
  const [currentCoordinates, setCurrentCoordinates] = useState({ lat: 17.4263, lng: 78.4305, zoom: 5 });
  const [lastUpdatedTime, setLastUpdatedTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
  const [selectedMarker, setSelectedMarker] = useState({});
  const [viewType, setViewType] = useState('maps');
  const [selectedTreeValue, setSelectedTreeValue] = useState({ Type: 'Site', Code: 'RenewableEnergy', Name: 'RenewableEnergy' });
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [markers, setMarkers] = useState([]);
  const eliminateKeysPopup = ['Name', 'Rated Capacity', 'TotalTurbines'];

  useEffect(() => {
    const fetchData = async () => {
      await onTreeSelect(selectedTreeValue.Type, selectedTreeValue.Code, selectedTreeValue.Name, viewType);
    };

    fetchData();

    const timeTicket = setInterval(() => {
      fetchData();
    }, 60000);

    return () => clearInterval(timeTicket);
  }, [selectedTreeValue, viewType]);

  const addMarkers = async (markerList) => {
    let currentCoords = {};
    const newMarkers = markerList &&
      Array.isArray(markerList) && markerList.map((mark) => ({
        title: mark.Name,
        value: mark.Code,
        AliasCode: mark.AliasCode,
        Type: mark.Type,
        ImageURL: mark.ImageURL,
        position: {
          lat: mark.Latitude,
          lng: mark.Longitude
        }
      }));

    if (markerList[0]?.ParentLatitude && markerList[0]?.ParentLongitude && markerList[0]?.ZoomUnit) {
      currentCoords = {
        lat: markerList[0].ParentLatitude,
        lng: markerList[0].ParentLongitude,
        zoom: markerList[0].ZoomUnit
      };
    } else {
      currentCoords = { lat: 17.4263, lng: 78.4305, zoom: 5 };
    }

    setCurrentCoordinates(currentCoords);
    setMarkers(newMarkers);
    setLastUpdatedTime(moment().format('YYYY-MM-DD HH:mm:ss'));
  };

  const onTreeSelect = async (Type, Code, Name, viewType) => {
    const newSelectedTreeValue = { Type, Code, Name };
    setSelectedTreeValue(newSelectedTreeValue);

    if (viewType === 'maps') {
      const markerLists = await _getMarkerList(newSelectedTreeValue);
      addMarkers(markerLists);
    } else {
      const dataSource = await _getTableData(newSelectedTreeValue);
      if (dataSource && dataSource[0] && Object.keys(dataSource[0])) {
        const eliminateKeys = ['Type', 'Code', 'Status', 'AliasCode', 'Rated Capacity'];
        const newColumns = Object.keys(dataSource[0])
          .filter((e) => !eliminateKeys.includes(e))
          .map((col) => ({
            title: col,
            dataIndex: col,
            key: col,
            width: 150,
            render: (text, record) => {

              if (col === 'Name' && record.Type === 'Device') {
                return (
                  <Tooltip placement="top" title={'Redirect to dashboard'}>
                    <div
                      style={{ fontWeight: 'bolder', color: '#045c6a', cursor: 'pointer' }}
                      onClick={() => {
                        if (record && record.Type === 'Device' && record.Code) {
                          const siteId = localStorage.get('currentSite');
                          props.navigate.push({
                            pathname: `/rubus/dashboard/Renewable Energy`,
                            state: {
                              DeviceCode: `${siteId}_${record.Code}`,
                              DeviceName: record.Name
                            }
                          });
                        }
                      }}
                    >
                      {text}
                    </div>
                  </Tooltip>
                );
              } else if (col === 'Name') {
                return (
                  <Tooltip placement="top" title={'Open Turbines'}>
                    <div
                      style={{ fontWeight: 'bolder', color: '#045c6a', cursor: 'pointer' }}
                      onClick={() => {
                        if (record && record.Type === 'Asset') {
                          onTreeSelect(record.Type, record.Code, record.Name, 'table');
                        }
                      }}
                    >
                      {text}
                    </div>
                  </Tooltip>
                );
              }
              return text;
            }
          }));
        setColumns(newColumns);
        setDataSource(dataSource);
      }
    }
  };

  const onMarkerClick = async (mark) => {
    const payload = { Code: mark.value, Type: mark.Type };
    const selectedMarkerData = await getDataForPopup(payload);
    setSelectedMarker(selectedMarkerData);
  };

  const generateTitle = (mark) => {
    if (selectedTreeValue.Type === 'Site') {
      return <div><span style={{ fontWeight: 'bold' }}>Site :</span> {mark.Name}</div>;
    } else if (mark.Type === 'Asset') {
      return <div><span style={{ fontWeight: 'bold' }}>Location :</span> {mark.Name}</div>;
    }
  };

  return (
    <div>
      <div style={{ color: 'black', display: 'flex', justifyContent: 'flex-end', backgroundColor: '#aad3df' }}>
        Last Updated Time:
        <div style={{ marginRight: '10px' }}> {lastUpdatedTime}</div>
      </div>
      <div className="App">
        <div className="sidebarLeft">
          <LeftSidePanel onTreeSelect={(Type, Code, Name) => onTreeSelect(Type, Code, Name, viewType)} />
        </div>
        <div style={{ backgroundColor: '#aad3df' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#aad3df' }}>
            <div style={{ color: 'black', margin: '0px 10px' }}>
              {generateTitle(selectedTreeValue)}
            </div>
            <div>
              <LeftSquareFilled style={{ margin: '5px', color: 'black' }} />
              {viewType === 'maps' ? (
                <a style={{ marginRight: '10px', color: 'black' }} onClick={() => {
                  setViewType('table');
                  onTreeSelect(selectedTreeValue.Type, selectedTreeValue.Code, selectedTreeValue.Name, 'table');
                }}>
                  Show Table
                </a>
              ) : (
                <a style={{ marginRight: '10px', color: 'black' }} onClick={() => {
                  setViewType('maps');
                  onTreeSelect(selectedTreeValue.Type, selectedTreeValue.Code, selectedTreeValue.Name, 'maps');
                }}>
                  Show GIS
                </a>
              )}
            </div>
          </div>
          {viewType === 'maps' ? (
            <Map center={[currentCoordinates.lat, currentCoordinates.lng]} zoom={currentCoordinates.zoom}>
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              {markers &&
                Array.isArray(markers) &&
                markers.map((mark, index) => (
                  <Marker
                    key={index}
                    icon={new L.Icon({
                      iconUrl: `${mark.ImageURL}`,
                      iconRetinaUrl: `${mark.ImageURL}`,
                      popupAnchor: [-0, -0],
                      iconSize: [50, 60]
                    })}
                    onClick={() => onMarkerClick(mark)}
                    onDoubleClick={() => {
                      if (mark.Type === 'Device') {
                        props.navigate({
                          pathname: `/rubus/dashboard/Renewable Energy`,
                          state: { DeviceCode: mark.AliasCode, DeviceName: mark.title }
                        });
                      } else if (mark.Type === 'Asset') {
                        onTreeSelect(mark.Type, mark.value, mark.Name, 'maps');
                      }
                    }}
                    position={[mark.position.lat, mark.position.lng]}
                  >
                    <Popup>
                      <div>
                        <div style={{ fontWeight: 'bold' }}>
                          {selectedMarker.Name || ''}
                        </div>
                        {selectedMarker &&
                          Object.keys(selectedMarker) &&
                          Object.keys(selectedMarker).length > 0
                          ? Object.keys(selectedMarker)
                            .filter((e) => !eliminateKeysPopup.includes(e))
                            .map((sMark) => {
                              return (
                                <div key={index}>
                                  {sMark} : {selectedMarker[sMark]}
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </Popup>
                  </Marker>
                ))}
            </Map>
          ) : (
            <div className="sidebarRight">
              <StyledTable size="small"
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                scroll={{ y: 800 }}
                style={{ margin: '5px', marginTop: 10 }}
                onRow={(record) => ({
                  onDoubleClick: async () => {
                    if (record.Type === 'Asset') {
                      onTreeSelect(record.Type, record.Code, record.Name, 'table');
                    }
                    if (record.Type === 'Device' && record.AliasCode) {
                      props.navigate({
                        pathname: `/rubus/dashboard/Renewable Energy`,
                        state: { DeviceCode: record.AliasCode, DeviceName: record.Name }
                      });
                    }
                  }
                })}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapWithClustering;